<template>
    <v-layout row justify-center>
        <v-dialog v-model="confirmModel" lazy max-width="600">
            <v-card>
                <v-card-title primary-title class="title grey lighten-2">{{ mainTitle }}</v-card-title>
                <v-card-text style="min-height: 100px;" class="blockquote">{{ secondTitle }}</v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat :color="cancel.color" @click.native.stop="$emit('update:confirmModel', false)" >{{ cancel.label }}
                    </v-btn>
                    <v-btn v-if="exit" flat :color="exit.color ? exit.color : 'error'" @click.native.stop="atExit()" >{{ exit.label ? exit.label : 'Esci' }}
                    </v-btn>
                    <v-btn flat :color="confirm.color" @click.native.stop="executeAtConfirm" >{{ confirm.label }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "confirm-dialog",
        props: {
            confirmModel: Boolean,
            mainTitle: {
                default: 'Sei sicuro di procedere con questa azione?',
                type: String
            },
            secondTitle: {
                default: 'Questa azione è irreversibile',
                type: String,
            },
            cancel: {
                default: () => { 
                    return {
                        color: 'primary',
                        label: 'Annulla',
                    }
                },
                type: Object,
            },
            exit: {
                default: null,
                type: Object,
            },
            confirm: {
                default: () => {
                    return {
                        color: 'info',
                        label: 'Salva',
                    }
                },
                type: Object,
            },
            atConfirm: {
                default: null,
                type: Function
            },
            atExit: {
                default: null,
                type: Function
            },
        },

        data() {
            return {
            }
        },

        methods: {
            executeAtConfirm() {
                this.atConfirm()
                this.$emit('update:confirmModel', false)
            }
        },
    }
</script>